let formModel = {
    full_name: '',
    club: '', 
    media:''
}
export default formModel;